"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleStore = void 0;
var mobx_1 = require("mobx");
var ExampleStore = /** @class */ (function () {
    function ExampleStore() {
        Object.defineProperty(this, "tel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this, {
            tel: mobx_1.observable,
            formattedTel: mobx_1.computed
        });
    }
    Object.defineProperty(ExampleStore.prototype, "setTel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (tel) {
            this.tel = tel;
        }
    });
    Object.defineProperty(ExampleStore.prototype, "formattedTel", {
        get: function () {
            var _a;
            return (_a = this.tel) === null || _a === void 0 ? void 0 : _a.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        },
        enumerable: false,
        configurable: true
    });
    return ExampleStore;
}());
exports.ExampleStore = ExampleStore;
exports.default = new ExampleStore();
